import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Typography, Grid, Button } from "@mui/material";
import { getCoupon, getDeleteCoupon } from "redux/actions/UserCouponAction";
import { getServiceCity } from "redux/actions/UserServiceCity";
import { getChooseYourService } from "redux/actions/UserChooseYourService";
import CommonForm from "components/commonForm/CommonForm";
import { couponFormData } from "./CouponFormData";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import Loader from "components/loader/Loader";
import useModal from "components/hooks/useModel";
import CommonDialog from "components/commonDialog/CommonDialog";
import { handlePermissions } from "utils/utils";
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import deleteicon from "assets/images/delete.svg";

function CouponDetails() {
  const { state } = useLocation() || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { open: openConfirm, toggle: setOpenConfirm } = useModal();
  const couponDetails = useSelector(
    (state) => state?.userCoupon?.userCoupon?.data?.body
  );
  console.log("couponDetails", couponDetails);
  const loader = useSelector((state) => state?.userCoupon?.loading);
  const locationData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  console.log("locationData", locationData);
  const dutyTypeOptions = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );
  console.log("dutyTypeOptions", dutyTypeOptions);
  const id = {
    couponId: state?.couponId,
  };

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const data = {
      id: companyId,
      type: "Company",
      businessType: 0,
    };
    dispatch(getCoupon(id));
    dispatch(getServiceCity());
    dispatch(getChooseYourService(data));
  }, [dispatch]);

  const onClickOpen = () => {
    setOpenConfirm(true);
  };

  const redirect = () => {
    setOpenConfirm(false);
    // Call getCoupon API to refresh the list, then navigate
    const companyId = localStorage.getItem("companyId");
    const data = {
      id: companyId,
      type: "Company",
      businessType: 0,
    };
    dispatch(getCoupon(data));
    navigate(-1);
  };

  const onDelete = () => {
    const val = {
      couponID: {
        id: state?.couponId,
      },
      redirect: redirect,
      key: "couponDetails"
    };
    dispatch(getDeleteCoupon(val));
  };



  const breadcrumbPaths = [
    { name: "Configuration", url: "/promotions", className: "colorBlue" },
    { name: "Coupon Details", url: "", className: "colorBlue" },
  ];

const defaultValues = {
  ...couponDetails,
  perventageValue: couponDetails?.discountValue,
  isNewUser: couponDetails?.isNewUser ? "isNewUser" : "existingUser",
  discountType:
  couponDetails?.type === "Flat Discount"
  ? "Flat"
  : couponDetails?.type === "Percentage Discount"
  ? "Percentage"
  : couponDetails?.type,
  category: couponDetails?.category,
  referralType: couponDetails?.referralType === "referee" || couponDetails?.referralType === "referrer"
      ? couponDetails?.referralType
      : "referee", // fallback to referee if undefined
};

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const configRoleEnum = roleAndPermissionEnum.configuration;

  const accessForall = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { defaultAllAccess: configRoleEnum?.subModules?.coupon?.all }
  );

  const accessForEdit = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.coupon?.edit }
  );

  const accessForDelete = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.coupon?.delete }
  );

  // const addAccess = (accessForall || accessForDelete);
  const addAccess = true;
  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="marginBlock10 paddingInline40"
      >
        <Grid item>
          <Typography className="colorBlue fw600 font20">
            Coupon {state?.couponCode} Details
          </Typography>
        </Grid>
        <Grid item>
          {addAccess && <Button className="dflex font16" onClick={onClickOpen}>
            <img src={deleteicon} alt="deleteicon" className="mr10" />
            <Typography className="textCapitalize colorBlack font16">
              Delete
            </Typography>
          </Button>}
        </Grid>
      </Grid>
      {loader ? (
        <Loader />
      ) : locationData && dutyTypeOptions ? (
        <div className="paddingInline40 paddingBottom20">
          <CommonForm
            formData={couponFormData("details", locationData, dutyTypeOptions)}
            defaultValues={defaultValues}
            disabled ={true}
            formName="couponDetailsForm"
            selectType="details"
          />
        </div>
      ) : (
        <Loader />
      )}

      {openConfirm ? (
        <CommonDialog
          open={openConfirm}
          handleClose={() => setOpenConfirm(false)}
          toggle={setOpenConfirm}
          onConfirmDialog={onDelete}
          text={"Are you sure to delete this coupon?"}
          selectType={"delete"}
          dialogContent={"couponDelete"}
        />
      ) : null}
    </div>
  );
}

export default CouponDetails;
